import { withStyles } from '@material-ui/core/styles';
import { HEALTH_PLAN_LIST_TITLE } from '../../libraries/texts';
import service from '../../services/health-plan-service';

import ListForm from '../maintainer/list';
import { MaintainerList as styles } from '../maintainer/styles';

export default withStyles(styles)(
  ListForm({ service, title: HEALTH_PLAN_LIST_TITLE, name: 'HEALTH_PLAN' })
);
